export type UserOnboardingSortBy =
  | 'first_name'
  | 'last_name'
  | 'email'
  | 'title'
  | 'phone_number'
  | 'clinics_and_roles'
  | 'invite_time'
  | 'last_login_time'
  | 'total_tasks_assigned'
  | 'total_tasks_submitted';

/**
 * Array of all UserOnboardingSortBy values.
 */
export const USERONBOARDINGSORTBY_VALUES: readonly UserOnboardingSortBy[] = [
  'first_name',
  'last_name',
  'email',
  'title',
  'phone_number',
  'clinics_and_roles',
  'invite_time',
  'last_login_time',
  'total_tasks_assigned',
  'total_tasks_submitted',
] as const;
